import * as z from 'zod';

export const RatControlServiceSchema = z.object({
    tariffConfigId: z.number().int().positive(),
    description: z.string(),
    price: z.number(),
});

export type RatControlService = z.infer<typeof RatControlServiceSchema>;
